import { getCoreDataSecurityAccessStatisticsSlice } from './get';

export const { requestGetCoreDataSecurityAccessStatistics, resetGetCoreDataSecurityAccessStatistics } =
	getCoreDataSecurityAccessStatisticsSlice.asyncActionCreators;
